import React from 'react'

const BlurBlueDecorationLarge = () => {
    return (
        <div className='blur-blue-decoration-large'></div>
    )
}

export default BlurBlueDecorationLarge